'use client';

import type { AxiosError } from 'axios';
import axios from 'axios';
import { enqueueSnackbar } from 'notistack';

import { logout } from '@/redux-store/utils/logout';
import { notifyErrorOnce } from '@/utils/error/notify-once';
import { unwrapError } from '@/utils/error/unwrap-api-error';
import { t } from '@/utils/lang';

const axiosClient = axios.create({
    baseURL: '',
    timeout: 10000,
    withCredentials: true, // cookie HttpOnly
});

axiosClient.interceptors.request.use(config => {
    const url = config.url || '';

    if (url.startsWith('/api/')) {
        config.url = `${url}`;
    }

    return config;
});

let didLogout = false;

function isAuthLogoutCall(url?: string) {
    const u = String(url ?? '');

    return u.includes('/api/auth/logout');
}

axiosClient.interceptors.response.use(
    res => res,
    async (error: AxiosError) => {
        const apiError = unwrapError(error);

        if (apiError.status === 401) {
            if (!didLogout && !isAuthLogoutCall(error.config?.url)) {
                didLogout = true;

                logout();
            }

            return Promise.reject(apiError);
        }

        notifyErrorOnce(t(apiError.message), msg =>
            enqueueSnackbar(msg, { variant: 'error' })
        );

        return Promise.reject(apiError);
    }
);

export default axiosClient;
